import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Http} from "@angular/http";
import {BehaviorSubject} from "rxjs";
import {environment} from "../../../environments/environment";

@Injectable()
export class TimetableService {

    private http: Http;
    private base = '';

    constructor(http: Http) {
        this.http = http;
        this.base = environment.backendUrl + 'api/timetable';
    }

    getTimetableApi(page = 1) {
        return this.http.post(this.base + '/', {page: page, limit: 2});
    }

    removeTimetable(slug) {
        return this.http.post(this.base + '/remove', {
                slug: slug
            });
    }

}


// WEBPACK FOOTER //
// /code/frontend/src/app/shared/services/timetable.service.ts